import styled from "styled-components";

const AddJobAllJobsProfile = styled.main`
  /* border: 2px solid red; */
  background-color: #fff;
  margin: 1rem 4vw;
  padding: 8px;
  border-radius: 10px;
  box-shadow: 0px 12px 12px 0px rgba(0, 0, 0, 0.1);

  .page__title {
    font-size: 2rem;
    font-weight: 600;
  }
  .page__intro {
    font-size: 20px;
    margin-bottom: 2.5rem;
  }

  @media screen and (max-width: 500px) {
    /* padding-block: 20px; */

    .page__title {
      font-size: 20px;
    }
    .page__intro {
      font-size: 16px;
      margin-bottom: 1.5rem;
    }
  }
`;

export default AddJobAllJobsProfile;
